// extracted by mini-css-extract-plugin
export default {"root":"ContextMenu_root__nOD1f"};